import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PhotoGrid from '../components/gallery/PhotoGrid';
import PhotoModal from '../components/gallery/PhotoModal';
import PublicUpload from '../components/gallery/PublicUpload';
import './Gallery.css';

const Gallery = () => {
  const [photos, setPhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const fetchGallery = async () => {
    try {
      const response = await api.get('/gallery');
      setPhotos(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching gallery photos:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  const openPhotoModal = (photo) => {
    setSelectedPhoto(photo);
  };

  const closePhotoModal = () => {
    setSelectedPhoto(null);
  };

  return (
    <div
      id="gallery"
      className="gallery-page"
      onMouseMove={handleMouseMove}
      style={{
        '--mouse-x': `${mousePos.x}px`,
        '--mouse-y': `${mousePos.y}px`
      }}
    >
      <div className="cursor-glaze"></div>
      <div className="container">
        <h1 className="page-title">PHOTO GALLERY</h1>
        
        <PublicUpload onUploadSuccess={fetchGallery} />

        {loading ? (
          <div className="loading">Loading gallery...</div>
        ) : (
          <PhotoGrid
            photos={photos}
            onPhotoClick={openPhotoModal}
          />
        )}
      </div>
      {selectedPhoto && (
        <PhotoModal
          photo={selectedPhoto}
          onClose={closePhotoModal}
        />
      )}
    </div>
  );
};

export default Gallery;